import { isProduct } from "@super-real/types";
import { query } from "firebase/firestore";
import { getCollectionRef } from "../../Firebase/helpers/getCollectionRef";
import { useValidCollectionData } from "../../Firebase/hooks/useValidCollectionData";

export const useProducts = () => {
  return useValidCollectionData(query(getCollectionRef("products")), isProduct);
};
